<template>
  <v-dialog
    v-model="dialog"
    max-width="1000"
    persistent
    transition="dialog-bottom-transition"
  >
    <div class="bg-white poppins position-relative">
      <div
        class="modal-header py-3 align-center bg-white position-sticky top-0 left-0 zindex-5"
      >
        <h4 class="mb-0 font-weight-bolder poppins">Return detail</h4>
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="20">mdi-close</v-icon>
          </span>
        </div>
      </div>
      <div class="modal-body d-flex flex-column scroll-y mx-5 mx-xl-15 py-7">
        <!--begin::Body-->
        <div v-for="(item, i) in other" :key="i">
          <pop-up-selector :item="item"></pop-up-selector>
        </div>
        <!--end::Body-->
      </div>
    </div>
  </v-dialog>
</template>

<script>
import PopUpSelector from "@/own/components/fulfillment/returned/popup/PopUpSelector.vue";
export default {
  name: "Others",
  components: { PopUpSelector },
  data: () => ({
    dialog: false,
    other: null,
  }),
  methods: {
    setData(otherData) {
      this.other = otherData;
    },
    toggleModal() {
      if (this.dialog) {
        this.other = null;
        this.dialog = !this.dialog;
      } else {
        this.dialog = !this.dialog;
      }
    },
  },
};
</script>

<style scoped>
div {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 15px;
}
.other_key {
  margin: 2px;
}
.other_value {
  font-weight: bold;
  margin: 2px;
  margin-inline-start: 6px;
}
.main {
  background-color: rgb(245, 245, 245);
}
</style>
